<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="ion-text-center">Pagar Suscripción</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="center">
    <ion-grid fixed>
      <ion-row>
        <ng-container *ngIf="!paymentUrl">
          <ion-col
            size="12"
            style="display: flex; justify-content: center; align-items: center"
          >
            <img
              src="./assets/logoblack-normal.png"
              style="width: auto; max-height: 125px"
            />
          </ion-col>

          <ion-col size="12">
            <form [formGroup]="paymentForm">
              <ion-list>
                <ion-radio-group formControlName="plan_id">
                  <ng-container *ngIf="subsList.length > 0; else spinner">
                    <ion-list-header>
                      <ion-label>Seleccionar plan</ion-label>
                    </ion-list-header>

                    <ion-item *ngFor="let sub of subsList">
                      <ion-label style="font-size: 12px"
                        >{{ sub.nombre }} 
                      
                        <p> Precio: {{ sub.precio }}</p>
                      
                        </ion-label
                      >
                      <ion-radio slot="start" value="{{ sub.id }}"></ion-radio>
                    </ion-item>
                  </ng-container>
                </ion-radio-group>
              </ion-list>
              <ng-template #spinner>
                <ion-col
                  size="12"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <ion-spinner></ion-spinner>
                </ion-col>
              </ng-template>
              <!-- <ion-item class="no-hover">
                <ion-label position="stacked">Seleccionar plan</ion-label>
                <ion-select placeholder="Plan" formControlName="plan_id">
                  <ion-select-option
                    value="{{ sub.id }}"
                    *ngFor="let sub of subsList"
                    >{{ sub.nombre }}-Precio:{{ sub.precio }}</ion-select-option
                  >
                </ion-select>
              </ion-item> -->
            </form>
          </ion-col>
          <ion-col size="12" *ngIf="!isLoading; else spinner">
            <ion-button
              type="submit"
              expand="block"
              [disabled]="paymentForm.invalid || isLoading"
              (click)="addPayment()"
            >
              Realizar pago
            </ion-button>
          </ion-col>
          <ion-col size="12" style="margin-top: 200px">
            <p class="ion-text-center">
              Si tienes problemas con el pago, escríbenos al WhatsApp
            </p>
            <!-- <ion-button
              (click)="socialMedia('whatsapp')"
              expand="full"
              color="success"
              style="width: 100%"
              [disabled]="!waText"
            >
              Abrir Whatsapp
            </ion-button> -->
            <app-wa-button type="button"></app-wa-button>
          </ion-col>
          <ng-template #spinner>
            <ion-col
              size="12"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner></ion-spinner>
            </ion-col>
          </ng-template>
        </ng-container>

        <ion-col size="12" *ngIf="paymentUrl">
          <iframe
            [src]="paymentUrl | safe"
            frameborder="0"
            height="800px"
            width="100%"
          ></iframe>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <!--
  <div
    style="
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    "
  >
    <img
      src="./assets/logoblack-normal.png"
      style="width: auto; max-height: 125px"
    />
    <h2>GRACIAS POR SU PAGO</h2>
  </div> -->
</ion-content>
